/*! Fasy: index.mjs
    v9.0.0 (c) 2021 Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
import concurrent from"./concurrent.mjs";import serial from"./serial.mjs";import transducers from"./transducers.mjs";export default{concurrent:concurrent,serial:serial,transducers:transducers};export{concurrent};export{serial};export{transducers};